import React from 'react';
import { PencilIcon, TrashIcon } from '@heroicons/react/24/solid';
import { Equipment } from '../../../../services/equipmentService';

interface TableRowProps {
    equipment: Equipment;
    onEdit: (equipment: Equipment) => void;
    onDelete: (equipment: Equipment) => void;
}

const EquipmentTableRow: React.FC<TableRowProps> = ({
    equipment,
    onEdit,
    onDelete,
}) => {
    return (
        <tr className="border-t">
            <td className="py-3 px-4">{equipment.id}</td>
            <td className="py-3 px-4">{equipment.name}</td>
            <td className="py-3 px-4">{equipment.group?.name || 'N/A'}</td>
            <td className="py-3 px-4">
                <img src={equipment.imageUrl} alt={equipment.name} className="w-16 h-16 object-cover rounded" />
            </td>
            <td className="py-3 px-4">
                <button
                    onClick={() => onEdit(equipment)}
                    className="px-2 py-1 mr-2 text-yellow-600 border border-yellow-600 rounded hover:bg-gray-100"
                >
                    <PencilIcon className="w-5 h-5" />
                </button>
                <button
                    onClick={() => onDelete(equipment)}
                    className="px-2 py-1 text-red-600 border border-red-600 rounded hover:bg-gray-100"
                >
                    <TrashIcon className="w-5 h-5" />
                </button>
            </td>
        </tr>
    );
};

export default EquipmentTableRow;
